<!-- @format -->

<div *ngIf="timesheet">
	<table id="time-entry" class="time-entry" [class.approvals-view]="isApprovalsView">
		<tr class="date-row">
			<td class="entry-type"></td>
			<td class="date-block weekend">
				Sat
				<div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 0) }}</div>
			</td>
			<td class="date-block weekend">
				Sun
				<div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 1) }}</div>
			</td>
			<td class="date-block">
				Mon
				<div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 2) }}</div>
			</td>
			<td class="date-block">
				Tue
				<div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 3) }}</div>
			</td>
			<td class="date-block">
				Wed
				<div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 4) }}</div>
			</td>
			<td class="date-block">
				Thu
				<div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 5) }}</div>
			</td>
			<td class="date-block">
				Fri
				<div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 6) }}</div>
			</td>
			<td></td>
		</tr>

		<ng-container *ngFor="let entry of timesheet.entries; let entryIndex = index">
			<tr
				class="entry-row"
				[class.remove-bottom-border]="entry.metadata.daysExceedingExpectedHours?.length || entry.metadata.isInvalidCDOEntry">
				<td class="entry-type">
					<div
						class="entry-type-label"
						[class.approvals-view]="isApprovalsView"
						(click)="onEditRow(entry, entryIndex)"
						[class.noPointer]="isNotAllowedEdit()">
						<div
							class="entry-type-colour"
							[style.background-color]="getEntryTypeColor(entry)"
							[class.description]="entry.metadata.description && entry.metadata.description.length > 0"></div>
						<div class="entry-description-all" [class.unknownEntry]="!nameToEntryText(entry)">
							<div>
								<strong>{{getEntryDisplayName(entry)}}</strong>
							</div>
							<div class="entry-description" *ngIf="entry.metadata.description">
								<span>{{entry.metadata.description}}</span>
							</div>
							<!-- <div class="entry-description" *ngIf="entry.metadata.comments"> {{entry.metadata.comments}} </div> -->
						</div>
					</div>
				</td>

				<ng-container *ngFor="let duration of entry.durations; let weekDayIndex = index; trackBy: trackByFn">
					<td class="entry-box-cell">
						<ng-container *ngIf="lockTimeEntry || entry.metadata.disableEdit">
							<div
								class="entry-box-locked"
								[ngbTooltip]="(entry.name === 'Overtime' || entry.name === 'Council') && entry.durations![weekDayIndex] > 0 ? tooltip : ''"
								[ngClass]="{'otToolTipInfo' : (entry.name === 'Overtime' || entry.name === 'Council') && entry.durations![weekDayIndex] > 0}">
								{{formatNumberDisplay(duration)}}
							</div>
						</ng-container>

						<ng-template #tooltip>
							<table class="otToolTip" [innerHTML]="getToolTip(entryIndex, weekDayIndex)"></table>
						</ng-template>
						<ng-container *ngIf="!lockTimeEntry && !entry.metadata.disableEdit">
							<input
								class="entry-box entry-box-input"
								[(ngModel)]="entry.durationsInDisplayFormat![weekDayIndex]"
								(ngModelChange)="convertToNumberAndUpdate($event, entryIndex, weekDayIndex)"
								(focusout)="handleFocusOut(entry, weekDayIndex)"
								type="text"
								(keypress)="cleanInput($event, false, entry, entry.durations, weekDayIndex)"
								(paste)="cleanInput($event, true, entry, entry.durations, weekDayIndex)"
								[class.greyInputText]="isDayLongerThanZeroHours(entry, weekDayIndex)"
								onClick="this.select()"
								[ngClass]="{'otToolTipInfo' : (entry.name === 'Overtime' || entry.name === 'Council') && entry.durations![weekDayIndex] > 0}"
								[ngbTooltip]="(entry.name === 'Overtime' || entry.name === 'Council') && entry.durations![weekDayIndex] > 0 ? tooltip : entry.name ==='Overtime' ?
                                'Enter your overtime hours excluding meal breaks. They will be automatically calculated for you.' : ''" />
						</ng-container>
					</td>
				</ng-container>

				<td *ngIf="!isApprovalsView" class="entry-box" [class.disabledBtns]="lockTimeEntry">
					<button (click)="deleteRow(entryIndex)" [disabled]="lockTimeEntry" class="button-removestyles">
						<i class="fa-light fa-trash fa-2xl"></i>
					</button>
				</td>
			</tr>

			<tr
				*ngIf="entry.metadata.daysExceedingExpectedHours?.length"
				class="entry-row-extension"
				[class.remove-bottom-border]="entry.metadata.isInvalidCDOEntry">
				<td colspan="9">
					<span class="hours-error">
						Allocate the extra hour(s) to another row. You've exceeded your scheduled hours for
						{{entry.metadata.daysExceedingExpectedHours | weekdayNames}}.
						<button (click)="entry.metadata.daysExceedingExpectedHours=[]" class="button-removestyles">
							<i class="fa-sharp fa-solid fa-xmark"></i>
						</button>
					</span>
				</td>
			</tr>

			<tr *ngIf="entry.metadata.isInvalidCDOEntry" class="entry-row-extension">
				<td colspan="9">
					<span class="hours-error">
						The number of hours for a CDO must be {{getRegularDayHours()}}.
						<button (click)="entry.metadata.isInvalidCDOEntry=false" class="button-removestyles">
							<i class="fa-sharp fa-solid fa-xmark"></i>
						</button>
					</span>
				</td>
			</tr>

			<tr *ngIf="entry.metadata.cdoShiftNotes && entry.metadata.cdoShiftNotes.length > 0" class="entry-row-extension">
				<td colspan="9">
					<span class="hours-cdoShift-info">
						{{entry.metadata.cdoShiftNotes}}.
						<button (click)="entry.metadata.cdoShiftNotes=''" class="button-removestyles">
							<i class="fa-sharp fa-solid fa-xmark"></i>
						</button>
					</span>
				</td>
			</tr>

			<tr *ngIf="entry.metadata.isBankedTimeError" class="entry-row-extension">
				<td colspan="9">
					<span class="hours-error">
						The number of hours for a banked time entry must be a multiple of {{getRegularDayHours()}}.
						<button (click)="entry.metadata.isBankedTimeError=false" class="button-removestyles">
							<i class="fa-sharp fa-solid fa-xmark"></i>
						</button>
					</span>
				</td>
			</tr>
		</ng-container>

		<ng-container *ngFor="let metadata of timesheet.metadata">
			<tr class="bankedCDO" *ngIf="metadata.bankedCDO">
				<div class="bankedCDONotice">
					<span
						>{{metadata.bankedCDO.description}}
						<span class="bankCDOUndo" (click)="handleUndoBankCDO()" *ngIf="!lockTimeEntry">Undo?</span></span
					>
				</div>
			</tr>
		</ng-container>

		<div class="add-row-btn" [class.disabledBtns]="lockTimeEntry" *ngIf="!isApprovalsView">
			<button (click)="onAddRow()" [disabled]="lockTimeEntry">
				<div class="add-row-circle"><span>+</span></div>
				<span>Add a row</span>
			</button>
		</div>

		<tr class="total-hours" [class.approvals-view]="isApprovalsView">
			<td class="totalHoursHeading" [class.approvals-view]="isApprovalsView">
				TOTAL HOURS
				<div class="remainingHours">Remaining hours to allocate</div>
			</td>

			<ng-container *ngFor="let entry of totalHoursEntered; let i = index;">
				<td class="column-sums totalHoursTime">
					{{ formatNumberDisplay(totalHoursEntered[i]) }}
					<div class="remainingHours">{{ formatNumberDisplay(remainingToAllocate[i]) }}</div>
				</td>
			</ng-container>

			<td></td>
		</tr>

		<tr *ngIf="showTooFewHoursError">
			<td colspan="9">
				<span class="hours-error">
					Allocate all remaining hours before submitting your timesheet.
					<button (click)="showTooFewHoursError=false" class="button-removestyles"><i class="fa-sharp fa-solid fa-xmark"></i></button>
				</span>
			</td>
		</tr>

		<tr *ngIf="showInvalidEntryError">
			<td colspan="9">
				<span class="entry-error">
					Time categories with an "*" are no longer valid as your Profile has been updated e.g. You have been reclassified as an Auxiliary
					employee from a Regular Full Time employee. Please resubmit your timesheet with the appropriate time category.
					<button *ngIf="!isApprovalsView" (click)="showInvalidEntryError=false" class="button-removestyles">
						<i class="fa-sharp fa-solid fa-xmark"></i>
					</button>
				</span>
			</td>
		</tr>
	</table>

	<ng-container *ngIf="!isApprovalsView">
		<div *ngIf="hasSubmittedTimesheet() && lockTimeEntry && !isTimesheetApproved()" class="submission-status">
			<i class="fa-regular fa-clock"></i>
			Pending approval
		</div>
		<div *ngIf="hasSubmittedTimesheet() && lockTimeEntry && isTimesheetApproved()" class="submission-status">
			<i class="fa-sharp fa-solid fa-circle-check"></i>
			Timesheet approved
		</div>
	</ng-container>

	<div *ngIf="!isApprovalsView" class="row justify-content-end">
		<div class="col-4 d-flex justify-content-end">
			<ng-container *ngIf="!hasSubmittedTimesheet()">
				<button type="button" class="btn btn-outline-primary add-btn mx-2" (click)="processTimesheet('save')">Save</button>
			</ng-container>

			<ng-container *ngIf="!lockTimeEntry && !isEditingEmployeeTimesheet">
				<button type="submit" *ngIf="!hasSubmittedTimesheet()" class="btn btn-primary submit-btn" (click)="processTimesheet('submit')">
					Submit
				</button>
				<button type="submit" *ngIf="hasSubmittedTimesheet()" class="btn btn-primary submit-btn" (click)="processTimesheet('submit')">
					Update
				</button>
			</ng-container>
			<ng-container *ngIf="isEditingEmployeeTimesheet">
				<button class="btn btn-primary submit-btn" (click)="processTimesheet('approve')">Update</button>
			</ng-container>
		</div>
	</div>
</div>
